import { Authority } from '@/shared/security/authority';

const EventSignupList = () => import('@/entities/bookable-event/event-signup-list-extended.vue');
const EventSignupUpdate = () => import('@/entities/bookable-event/event-signup-update-extended.vue');
const EventSignupDetails = () => import('@/entities/bookable-event/event-signup-details-extended.vue');

export default [
  {
    path: '/event-signups',
    name: 'EventSignupList',
    component: EventSignupList,
    meta: { authorities: [Authority.ADMIN, Authority.EVENT_SIGNUP] },
  },
  {
    path: '/event-signups/new',
    name: 'EventSignupCreate',
    component: EventSignupUpdate,
    meta: { authorities: [Authority.ADMIN, Authority.EVENT_SIGNUP] },
  },
  {
    path: '/event-signups/:id/edit',
    name: 'EventSignupEdit',
    component: EventSignupUpdate,
    meta: { authorities: [Authority.ADMIN, Authority.EVENT_SIGNUP] },
  },
  {
    path: '/event-signups/:id',
    name: 'EventSignupDetails',
    component: EventSignupDetails,
    meta: { authorities: [Authority.ADMIN, Authority.EVENT_SIGNUP] },
  },
];
